import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { Spinner } from '@ui/themed';
import type { PropsWithChildren } from 'react';

export function AuthButton({
  loading,
  disabled = false,
  children,
}: PropsWithChildren<{ loading: boolean; disabled?: boolean }>) {
  return (
    <button
      type="submit"
      disabled={loading || disabled}
      className={cn(
        'flex w-full justify-center rounded-md border border-spark-border-contrast bg-spark-accent-solid px-4 py-3 font-medium text-sm text-spark-text-inverse shadow-xs hover:brightness-125 focus:outline-hidden focus:ring-2 focus:ring-spark-accent-hover focus:ring-offset-2 focus:ring-offset-spark-surface disabled:opacity-50',
        (loading || disabled) && 'cursor-not-allowed',
      )}
    >
      {loading && <Spinner className="-ms-8 me-3 size-5 text-spark-text-inverse" />}
      {children}
    </button>
  );
}
